module.exports = __webpack_public_path__ + "yadokari_creative_2_2.png?709787dff8aceb281623446d033411df";


//////////////////
// WEBPACK FOOTER
// ./static/img/yadokari_creative_2_2.png
// module id = 462
// module chunks = 0